import { useState, useEffect } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { useQuery } from "@apollo/client";
import { getOnlyValues, sanitizeMapBound, useFilters } from "../../../../Components/Filters/Filters.hook";
import { encodeHashUrl } from "../../../../Utils/Functions";
import { useRouter } from "next/router";
import { QUERY_AVAILABLE_FILTERS } from "shared-components/GQL";
import { getFormattedFilters } from "src/utils/Functions";
import { useRoutesContext } from "src/contexts/RoutesContext";

const QUERY_SEARCH_URL = gql`
	query searchUrl($params: SearchParamsInput!) {
		searchUrl(params: $params) {
			url
		}
	}
`;

const BOOLEAN_PARAM_KEYS = [
	"hasGarage",
	"tour3d",
	"privateOwner",
	"socialHousing",
	"seen",
	"seaview",
	"projects",
];

const normalizeSearchParams = (params: Record<string, unknown>): Record<string, unknown> => {
	if (!params) return params;
	const normalized = { ...params };
	for (const key of BOOLEAN_PARAM_KEYS) {
		if (key in normalized && normalized[key] != null) {
			normalized[key] = Boolean(normalized[key]);
		}
	}
	return normalized;
};

const useSearchResultsFilters = () => {
	const { filters, changeFilters, filtersTags } = useFilters();
	const RoutesContext = useRoutesContext();
	const router = useRouter();

	//Merge PD: ESTO VIENE DEUY< EVALUAR PARA QUÉ
	// useEffect(() => {
	// 	const handlePopstate = () => {
	// 		window.location.reload();
	// 	};
	// 	window.addEventListener("popstate", handlePopstate);

	// 	return () => {
	// 		window.removeEventListener("popstate", handlePopstate);
	// 	};
	// }, []);

	const [fetchSearchUrl] = useLazyQuery(QUERY_SEARCH_URL, {
		variables: {
			params: normalizeSearchParams((getFormattedFilters(filters) ?? {}) as Record<string, unknown>), //Merge PD: en UY no se pasa variables, solo está el onComplete
		},
		onCompleted: dataURL => {
			if (typeof window !== "undefined" && window.history && updateURL) {
				router.push({
					pathname: "/searchPage",
					query: { hashed: encodeHashUrl({ filters: filtersTags }) },
				}, dataURL.searchUrl.url).then(()=> {
					RoutesContext.setRoutes({ loading: false })
				})
			}
		},
	});
	  
	const changeFiltersAndUpdateURL = (new_filters) => {
		let somethingChanged = false;

		if(new_filters) {
			Object.keys(new_filters).map(key => {
				let new_value, old_value;

				if (Array.isArray(new_filters[key])) {
					new_value = JSON.stringify(new_filters[key]);
            		old_value = JSON.stringify(filters[key] || []);
				} else if (typeof new_filters[key] === 'object') {
					new_value = JSON.stringify(new_filters[key]);
					old_value = JSON.stringify(filters[key] || {});
				} else {
					new_value = new_filters[key]?.value ?? undefined;
            		old_value = filters[key]?.value ?? undefined;
				}

				if (old_value != new_value) {
					somethingChanged = true;
				}
			})
		}

		if(!somethingChanged) return;

		RoutesContext.setRoutes({ loading: true })

		changeFilters(new_filters).then((currentFilters) => {
			let formatCurrentFilters = sanitizeMapBound(getOnlyValues(currentFilters));
			
			const appliedFilters = { ...filters };
			appliedFilters.page = 1;
			
			const params = normalizeSearchParams({ ...appliedFilters, ...formatCurrentFilters } as Record<string, unknown>);
			fetchSearchUrl({ variables: { params } });
		});
	};

	const updateURL = () => {
		let formatCurrentFilters = sanitizeMapBound(getOnlyValues(filtersTags));

		const params = normalizeSearchParams({ ...filters, ...formatCurrentFilters } as Record<string, unknown>);
		fetchSearchUrl({ variables: { params } });
	}

	const { data, loading, error } = useQuery(QUERY_AVAILABLE_FILTERS);

	return {
		data,
		loading,
		error,
		changeFiltersAndUpdateURL,
		updateURL
	};
};

export { useSearchResultsFilters };
